import { toolRunQueryExpressionResolvedArgsSchemaTransformed, } from './filterExpressions/resolvedArgs';
import { parsePersistedRunQueryArgs, } from './tools/toolRunQueryArgs';
/**
 * Parses every supported persisted run-query shape. Existing formats take
 * their unchanged parser path; only per-category filter payloads use the
 * filter-expression transform.
 */
export const parsePersistedRunQueryPayload = (raw) => {
    const existing = parsePersistedRunQueryArgs(raw);
    if (existing !== null)
        return existing;
    const resolved = toolRunQueryExpressionResolvedArgsSchemaTransformed.safeParse(raw);
    return resolved.success ? resolved.data : null;
};
//# sourceMappingURL=persistedRunQueryArgs.js.map